import { render, staticRenderFns } from "./FilterPopup.vue?vue&type=template&id=b2abfb4c"
import script from "./FilterPopup.vue?vue&type=script&lang=ts"
export * from "./FilterPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2abfb4c')) {
      api.createRecord('b2abfb4c', component.options)
    } else {
      api.reload('b2abfb4c', component.options)
    }
    module.hot.accept("./FilterPopup.vue?vue&type=template&id=b2abfb4c", function () {
      api.rerender('b2abfb4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/FilterPopup.vue"
export default component.exports